module.exports = __webpack_public_path__ + "img/liwu-en.8de18ce5.webp";